import { Layout } from 'antd';
import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import { PageSkeleton } from '../Common/Skeletons';

const { Content } = Layout;

const AdminRoute = ({ children }) => {
  const { currentUser, userProfile, profileLoading } = useAuth();
  const { isDarkMode } = useTheme();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!profileLoading) {
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [profileLoading]);

  if (isLoading || profileLoading) {
    return (
      <div style={{
        height: '100vh',
        width: '100vw',
        backgroundColor: isDarkMode ? '#141414' : '#f0f2f5'
      }}>
        <Content style={{ padding: '24px' }}>
          <PageSkeleton rows={4} title={false} />
        </Content>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!userProfile?.is_admin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
